import { render, staticRenderFns } from "./room-list.vue?vue&type=template&id=0fed41e6&scoped=true&"
import script from "./room-list.vue?vue&type=script&lang=js&"
export * from "./room-list.vue?vue&type=script&lang=js&"
import style0 from "./room-list.vue?vue&type=style&index=0&id=0fed41e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed41e6",
  null
  
)

export default component.exports